import Phaser from 'phaser';
import type { PlayerFaction } from '@roe/shared';
import { GAME_W, GAME_H, setupCamera } from '../dpr.js';
import { GameStateManager } from '../state/GameStateManager';

export class FactionSelectScene extends Phaser.Scene {
  private gsm!: GameStateManager;

  constructor() {
    super({ key: 'FactionSelectScene' });
  }

  create(): void {
    setupCamera(this, this.cameras.main, 'full');
    this.gsm = GameStateManager.getInstance();
    this.cameras.main.setBackgroundColor('#0f0f23');
    const width = GAME_W; const height = GAME_H;

    // Title
    this.add.text(width / 2, 40, 'CHOOSE YOUR FACTION', {
      fontSize: '28px', fontFamily: 'Georgia, serif', color: '#c8973a', fontStyle: 'bold',
    }).setOrigin(0.5);

    this.add.text(width / 2, 75, 'This choice defines your base style and available races', {
      fontSize: '12px', fontFamily: 'Georgia, serif', color: '#6b7280',
    }).setOrigin(0.5);

    // Alliance card
    this.createFactionCard(
      width * 0.28, height * 0.5,
      'ALLIANCE',
      'alliance',
      0x3b82f6,
      [
        'Humans, Elves, Dwarves',
        'Strong healing & defense',
        'Kingdom Base',
        'Order, honor, unity',
      ],
    );

    // Horde card
    this.createFactionCard(
      width * 0.72, height * 0.5,
      'HORDE',
      'horde',
      0xef4444,
      [
        'Orcs, Undead, Goblins',
        'High damage & aggression',
        'Stronghold Base',
        'Strength, survival, fury',
      ],
    );

    // VS text
    this.add.text(width / 2, height * 0.5, 'VS', {
      fontSize: '32px', fontFamily: 'Georgia, serif', color: '#374151', fontStyle: 'bold',
    }).setOrigin(0.5);
  }

  private createFactionCard(
    x: number, y: number, title: string, faction: PlayerFaction,
    color: number, traits: string[],
  ): void {
    const cardW = 280;
    const cardH = 340;

    // Card bg
    const bg = this.add.rectangle(x, y, cardW, cardH, 0x1e293b, 0.9);
    bg.setStrokeStyle(2, color);
    bg.setInteractive({ useHandCursor: true });

    // Faction icon (large colored rectangle for now)
    this.add.rectangle(x, y - 90, 80, 80, color, 0.8);

    // Title
    this.add.text(x, y - 30, title, {
      fontSize: '22px', fontFamily: 'Georgia, serif', color: `#${color.toString(16).padStart(6, '0')}`,
      fontStyle: 'bold',
    }).setOrigin(0.5);

    // Traits
    traits.forEach((trait, i) => {
      this.add.text(x, y + 10 + i * 24, trait, {
        fontSize: '12px', fontFamily: 'Georgia, serif', color: '#d1d5db',
      }).setOrigin(0.5);
    });

    // Select button
    const btn = this.add.text(x, y + cardH / 2 - 30, `SELECT ${title}`, {
      fontSize: '14px', fontFamily: 'Georgia, serif', color: '#ffffff',
      backgroundColor: `#${color.toString(16).padStart(6, '0')}`,
      padding: { x: 16, y: 8 },
    }).setOrigin(0.5).setInteractive({ useHandCursor: true });

    // Hover effects
    bg.on('pointerover', () => bg.setFillStyle(0x2d3748, 0.95));
    bg.on('pointerout', () => bg.setFillStyle(0x1e293b, 0.9));

    const selectFaction = () => {
      this.gsm.setFaction(faction);
      this.scene.start('HeroSelectScene');
    };

    bg.on('pointerdown', selectFaction);
    btn.on('pointerdown', selectFaction);
    btn.on('pointerover', () => btn.setAlpha(0.8));
    btn.on('pointerout', () => btn.setAlpha(1));
  }
}
